// 微信相关配置
export const WECHAT_CONFIG = {
  // 微信公众号AppID - 需要替换为实际的AppID
  appId: process.env.REACT_APP_WECHAT_APP_ID || 'wx98ab678185dc8c67',

  // 授权回调地址 - 动态获取
  get redirectUri() {
    // const baseUrl = process.env.REACT_APP_WECHAT_REDIRECT_URI || 
    //                (typeof window !== 'undefined' ? 'https://form.fangxiaojia.vip/microform-test/wechat-auth' : 'https://form.fangxiaojia.vip/microform-test/wechat-auth');
    // const baseUrl = 'https://form.fangxiaojia.vip/microform-test/wechat-auth'; // 临时测试域名
    const baseUrl = typeof window !== 'undefined' ? `${window.location.origin}/wechat-auth` : '/wechat-auth'; // 动态获取当前域名
    return encodeURIComponent(baseUrl);
  },
  
  // 环境名称
  envName: process.env.NODE_ENV || 'production',

  // 授权作用域
  scope: 'snsapi_userinfo', // 获取用户信息

  // 状态参数
  state: 'wechat_auth',

  // 微信授权URL
  authUrl: 'https://open.weixin.qq.com/connect/oauth2/authorize',

  // 获取access_token的URL
  accessTokenUrl: 'https://api.weixin.qq.com/sns/oauth2/access_token',

  // 获取用户信息的URL
  userInfoUrl: 'https://api.weixin.qq.com/sns/userinfo'
};

// 检查是否在微信浏览器中
export const isWechatBrowser = () => {
  return /MicroMessenger/i.test(navigator.userAgent);
};

// 检查是否在微信小程序中
export const isWechatMiniProgram = () => {
  return window.__wxjs_environment === 'miniprogram';
};

// 构建微信授权URL
export const buildWechatAuthUrl = (customState = null) => {
  const { appId, redirectUri, scope, authUrl } = WECHAT_CONFIG;
  
  // 使用自定义state或默认state
  let state = customState || WECHAT_CONFIG.state;
  
  // 如果没有自定义state，检查是否有保存的返回URL
  if (!customState) {
    const returnUrl = localStorage.getItem('returnUrl');
    if (returnUrl) {
      try {
        const url = new URL(returnUrl);
        const path = url.pathname;
        // 如果是表单详情页面，使用路径作为state
        if (path.startsWith('/detail/')) {
          state = path.substring(1); // 移除开头的斜杠
        }
      } catch (error) {
        console.warn('解析returnUrl失败，使用默认state:', error);
      }
    }
  }
  
  return `${authUrl}?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
};

// 生成微信绑定二维码URL
export const generateWechatBindUrl = (userId) => {
  const { appId, redirectUri, scope, authUrl } = WECHAT_CONFIG;
  const state = `bind_${userId}`;
  return `${authUrl}?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
};

// 微信用户信息存储key
export const WECHAT_STORAGE_KEYS = {
  USER: 'wechatUser',
  TOKEN: 'wechatToken',
  LOGIN_STATUS: 'isWechatLoggedIn',
  RETURN_URL: 'wechatReturnUrl'
};

// 获取微信用户信息
export const getWechatUser = () => {
  const userStr = localStorage.getItem(WECHAT_STORAGE_KEYS.USER);
  return userStr ? JSON.parse(userStr) : null;
};

// 获取微信token
export const getWechatToken = () => {
  return localStorage.getItem(WECHAT_STORAGE_KEYS.TOKEN);
};

// 检查微信登录状态
export const isWechatLoggedIn = () => {
  return localStorage.getItem(WECHAT_STORAGE_KEYS.LOGIN_STATUS) === '1';
};

// 清除微信登录信息
export const clearWechatAuth = () => {
  Object.values(WECHAT_STORAGE_KEYS).forEach(key => {
    localStorage.removeItem(key);
  });
}; 